import { CONFIGURATOR_SECTION_GROUPS } from './configuratorSections';

export const VEST_SECTION_PAIRS = [
    ['coupe.addVest', 'vest.cut'],
    ['coupe.addVest.buttonholeColor', 'vest.buttonhole'],
    ['coupe.vestBackFabric', 'vest.backFabric'],
    ['perso.vestButtons', 'vest.buttons'],
    ['perso.vestPockets', 'vest.pockets'],
    ['perso.vestLapels', 'vest.lapels'],
    ['perso.vestLapels.size', 'vest.lapels.size'],
    ['perso.vestBack', 'vest.back'],
    ['perso.vestContrast', 'vest.contrast'],
    ['perso.embroidery', 'vest.embroidery'],
    ['perso.embroidery.threadColor', 'vest.embroidery.threadColor'],
    ['perso.embroidery.size', 'vest.embroidery.size'],
    ['perso.embroidery.font', 'vest.embroidery.font'],
] as const;

const standaloneKeys = new Set(VEST_SECTION_PAIRS.map(([, key]) => key));
const vestGroupKeys = new Set<string>([
    'coupe.addVest',
    'coupe.addVest.buttonholeColor',
    'coupe.vestBackFabric',
    'perso.vestButtons',
    'perso.vestPockets',
    'perso.vestLapels',
    'perso.vestLapels.size',
    'perso.vestBack',
    'perso.vestContrast',
]);
const vestSections = CONFIGURATOR_SECTION_GROUPS
    .flatMap((group) => group.sections)
    .filter((section) => vestGroupKeys.has(section.key) || section.key === 'vest.fabric');

/** Une seule ligne de réglage par option commune, avec le tissu principal propre au gilet seul. */
export const ADMIN_SECTION_GROUPS = CONFIGURATOR_SECTION_GROUPS.map((group) => ({
    ...group,
    sections: group.id === 'standaloneVestConfiguration'
        ? vestSections
        : group.sections.filter((section) => !standaloneKeys.has(section.key as typeof VEST_SECTION_PAIRS[number][1]) && !vestGroupKeys.has(section.key)),
})).filter((group) => group.sections.length > 0);

export const mirrorVestValues = <T>(values: Record<string, T>): Record<string, T> => {
    const result = { ...values };
    for (const [shared, standalone] of VEST_SECTION_PAIRS) {
        if (result[shared] === undefined) delete result[standalone];
        else result[standalone] = result[shared];
    }
    return result;
};

export const mirrorVestItems = <T>(values: Record<string, Record<string, T>>): Record<string, Record<string, T>> => {
    const result = { ...values };
    for (const [shared, standalone] of VEST_SECTION_PAIRS) {
        if (result[shared] === undefined) delete result[standalone];
        else result[standalone] = { ...result[shared] };
    }
    return result;
};

export const mirrorVestCategories = <T>(values: Record<string, T>): Record<string, T> => {
    const result = { ...values };
    for (const [shared, standalone] of VEST_SECTION_PAIRS) {
        for (const key of Object.keys(result)) {
            if (key.startsWith(`${standalone}:`)) delete result[key];
        }
        for (const [key, value] of Object.entries(result)) {
            if (key.startsWith(`${shared}:`)) result[`${standalone}:${key.slice(shared.length + 1)}`] = value;
        }
    }
    return result;
};
